import api from '@/shared/api';

export async function checkPrefixConflicts(prefixes: string[]): Promise<string[]> {
  const response = await api.get('/documents/prefix-conflicts', {
    params: { prefixes: prefixes.join(',') },
  });
  return response.data.data ?? [];
}
